module.exports = __webpack_public_path__ + "static/media/letter-auto-generate.5ba14b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/letter-auto-generate.png
// module id = 358
// module chunks = 1